'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
what does it look like?

styles
  * border
  * background white
  * width: 100%
  * display flex
 */

var defaultStyle = exports.defaultStyle = {
  alignItems: 'center',
  display: 'flex',
  height: '50px',
  textAlign: 'left',
  opacity: '0.56',
  margin: '10px 0',
  position: 'relative',
  justifyContent: 'space-between',
  width: '100%',
  '&:focusing': {
    opacity: '1'
  },
  '& input': {
    border: '0',
    fontSize: '18px',
    padding: '0 50px',
    width: '100%'
  },
  '& input:focus': {
    outline: 'none'
  },
  '& .icons': {
    height: '100%',
    lineHeight: '50px',
    position: 'absolute',
    textAlign: 'center',
    top: 0,
    width: '50px'
  },
  '& .icons.clear': {
    cursor: 'pointer',
    right: 0
  }
};

// This is where you might want to apply themed content.
// When it becomes obvious what our needs are for theming components like Navbars/Footers,
// we can do that here! :DDDD Until then, I am leaving this function here so that we will
// have some scaffolding ready in the future.
var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(_ref, theme) {
  var disabled = _ref.disabled,
      focused = _ref.focused;
  return {
    border: focused ? theme.borderBase * 1 + 'px solid ' + theme.colors.primary : theme.borderBase * 1 + 'px solid ' + theme.colors.primaryVeryLight,
    backgroundColor: theme.colors.primaryInverse,
    cursor: disabled ? 'not-allowed' : 'default',
    opacity: disabled ? '0.27' : '1'
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/SearchInput/SearchInput.style.js
// module id = 483
// module chunks = 0